/**
 * Last step
 */
import React, { useState, useEffect } from 'react';
import HttpStatus from 'http-status-codes';
import { useTranslation } from 'react-i18next';
/**
* Material UI
*/
import { makeStyles } from '@mui/styles';
/**
 * Redux
 */
import { useSelector } from 'react-redux';
import { leadState } from '../redux/leadSlice';
/**
 * Helpers
 */
import api from '../helpers/api';
/**
 * Components
 */
import Rating from '../components/Rating';
import { getToken } from '../helpers/auth';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 16,
    display: 'flex',
    flexDirection: 'column',
  },
  titleWrapper: {
    ...theme.mixins.marginXAuto,
    paddingTop: 30,
    paddingBottom: 40,
    fontWeight: 'bold',
    fontSize: 30,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 20,
    marginRight: 20,
    lineHeight: 1.1,
    color: theme.palette.primary.contrastText,
  },
  subtitleWrapper: {
    ...theme.mixins.marginXAuto,
    display: 'flex',
    flexDirection: 'column',
    fontSize: 20,
    marginLeft: 20,
    marginRight: 20,
    color: theme.palette.primary.contrastText,
    paddingBottom: 90,
  },
  ratingTestWrapper: {
    ...theme.mixins.marginXAuto,
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 20,
    marginRight: 20,
    color: theme.palette.primary.contrastText,
  },
  ratingWrapper: {
    ...theme.mixins.marginXAuto,
    paddingTop: 10,
    paddingBottom: 30,
  },
}));

function ThankYou() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { leadId } = useSelector(leadState);
  const [interactive, setInteractive] = useState(true);

  const onRate = async (value) => {
    const res = await api.patch({
      entryPoint: `/lead/${leadId}/feedback`,
      headers: { 'ga-token': getToken(leadId) },
      silentFail: true,
      data: { value },
    });
    if (res.status === HttpStatus.OK) {
      setInteractive(false);
    }
  };
  const completeLead = async () => {
    const res = await api.post({
      headers: { 'ga-token': getToken(leadId) },
      entryPoint: `/lead/${leadId}/complete`,
      silentFail: true,
    });
    if (res.status === HttpStatus.OK) {
      if (window?.ecommerceData?.thank_you_url) {
        const thankYouUrl = window.ecommerceData.thank_you_url;
        setTimeout(() => {
          window.location.replace(window.location.origin + thankYouUrl);
        }, 5000);
      }
    }
  };

  useEffect(() => {
    completeLead();
  }, []);

  return (
    <div>
      <div className={`ecommerce-thankyou ${classes.wrapper}`}>
        <div className={`title ${classes.titleWrapper}`}>
          <span className="text-center">{`${t('Thankyou')}!`}</span>
          <span className="text-center">{`${t('We have received all the necessary data')}`}</span>
        </div>
        <div className={`subtitle ${classes.subtitleWrapper}`}>
          <span className="text-center">{`${t('Our Customer Service will contact you as soon as possible')}.`}</span>
        </div>
        <div className={`rating-test-wrapper ${classes.ratingTestWrapper}`}>
          <span className="text-center">
            {t('How do you rate your shopping experience on our site?')}
          </span>
        </div>
        <div className={`rating-wrapper ${classes.ratingWrapper}`}>
          <Rating onRate={onRate} interactive={interactive} />
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
